export const getfavreq="getfavreq"
export const getfavsucc='getfavsucc'
export const getfavfail="getfavfail"